/* src/app/pages/ui-kit/components/button-view/button-view.component.scss */
.demo {
  display: grid;
  gap: 24px;
}
.box {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
  margin-bottom: 16px;
}
.box:last-child {
  margin-bottom: 0;
}
.pa-button-host-debug {
  border: 1px dashed rgba(255, 0, 0, 0.7);
  background: rgba(255, 0, 0, 0.06);
  padding: 0;
}
.pa-button-host-debug--full-width {
  max-width: 320px;
}
.pa-button-host-debug--forced-width {
  max-width: 320px;
  width: 320px;
}
.click-zone-box {
  background: rgba(0, 128, 255, 0.04);
  border: 1px dashed rgba(0, 128, 255, 0.7);
  margin-bottom: 8px;
  padding: 8px;
}
.click-zone-box--wide {
  width: 320px;
}
.click-zone-hint {
  color: var(--text-default);
  font-size: 13px;
  line-height: 18px;
  margin: 0 0 16px;
  max-width: 420px;
}
.click-result {
  margin: 0;
  font-size: 14px;
  color: var(--contrast-text);
}
/*# sourceMappingURL=button-view.component.css.map */
